const TEXT = 0;
const IMAGE = 1;
const COURSE = 4;
const CLASS = 5;
const QUIZ = 7;
const EDUCATOR = 10;
const DOCUMENT = 17;
const CLASS_RESCHEDULE = 18;
const LEADERBOARD = 19;
const PRACTICE_PUBLISHED = 20;
const COURSE_EDIT = 21;

export {
  TEXT,
  IMAGE,
  COURSE,
  CLASS,
  QUIZ,
  EDUCATOR,
  DOCUMENT,
  CLASS_RESCHEDULE,
  LEADERBOARD,
  PRACTICE_PUBLISHED,
  COURSE_EDIT
};
